const InfoWarningBig = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_68)">
      <rect width="64" height="64" rx="32" fill="#225AEA" />
      <rect width="64" height="64" rx="32" fill="url(#paint0_linear_1_68)" />
      <g opacity="0.4">
        <path
          d="M24.7019 8.67755C24.3355 7.31275 22.9259 6.49035 21.6043 6.99115C15.6098 9.25957 10.6843 13.6941 7.80111 19.4183C7.16431 20.6823 7.83471 22.1703 9.15471 22.6759C10.4747 23.1831 11.9419 22.5143 12.6107 21.2679C14.864 17.0586 18.5171 13.7687 22.9387 11.9671C24.2491 11.4327 25.0667 10.0439 24.7019 8.67915V8.67755Z"
          fill="#F2F6FF"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.0368 22.2373C30.3598 19.9693 33.6368 19.9693 34.9598 22.2373L42.9803 35.9867C44.3136 38.2724 42.6649 41.1428 40.0188 41.1428H23.9778C21.3317 41.1428 19.683 38.2724 21.0163 35.9867L29.0368 22.2373ZM31.9994 27.4286C32.6306 27.4286 33.1423 27.9403 33.1423 28.5714V32C33.1423 32.6312 32.6306 33.1429 31.9994 33.1429C31.3683 33.1429 30.8566 32.6312 30.8566 32V28.5714C30.8566 27.9403 31.3683 27.4286 31.9994 27.4286ZM30.5709 35.4286C30.5709 34.6396 31.2105 34 31.9994 34C32.7884 34 33.428 34.6396 33.428 35.4286C33.428 36.2176 32.7884 36.8572 31.9994 36.8572C31.2105 36.8572 30.5709 36.2176 30.5709 35.4286Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_68"
        x1="32"
        y1="0"
        x2="32"
        y2="64"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.16" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_1_68">
        <rect width="64" height="64" rx="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default InfoWarningBig
